/* eslint-disable max-len */
import React, { useMemo } from 'react';
import CheckIcon from '../../svgs/CheckIcon';
import DeactivateStaff from '../../svgs/DeactivateStaff';
import './MerchantDropdown.scss';

interface IMerchantDropdown{
    data?:any[];
    handleDropdown?:any;
    details?:any;
    fontSize?:any;
    hasClassName?:string;
    mouseEnterState?:any;
    checkmouseEvent?:boolean;
    hasActiveAndInactiveStatus?:boolean;
    dropdownActiveDetails?:any;
    dropdownDeActiveDetails?:any;
    hasWrapper?:boolean
}
const MerchantDropdown = ({
  data, handleDropdown, details, fontSize, hasClassName, mouseEnterState, checkmouseEvent, hasActiveAndInactiveStatus,
  dropdownActiveDetails, dropdownDeActiveDetails, hasWrapper,
}:IMerchantDropdown) => {
  const handleMouseEnter = (title) => {
    mouseEnterState({
      checkState: true, title,
    });
  };

  const handleMouseLeave = (title) => {
    mouseEnterState({
      checkState: false, title,
    });
  };

  const newFormatedData = useMemo(() => {
    const base = [...(data || [])];
    if (hasActiveAndInactiveStatus && details?.status !== 'pending') {
      const isActive = details?.status === 'active' || details?.status === 'ACTIVE';
      const tail = {
        title: isActive
          ? dropdownActiveDetails?.name || 'Deactivate'
          : dropdownDeActiveDetails?.name || 'Activate',
        icon: isActive
          ? dropdownActiveDetails?.icon || <DeactivateStaff />
          : dropdownDeActiveDetails?.icon || <CheckIcon color="rgba(59, 221, 153, 1)" width="10px" height="10px" />,
        color: isActive
          ? dropdownActiveDetails?.color || 'rgba(255, 89, 89, 1)'
          : dropdownDeActiveDetails?.color || 'rgba(71, 84, 103, 1)',
      };
      return [...base, tail];
    }
    return base;
  }, [data, details, hasActiveAndInactiveStatus, dropdownActiveDetails, dropdownDeActiveDetails]);

  const rowStyle = {
    color: undefined as string | undefined,
    display: 'flex' as const,
    alignItems: 'center' as const,
    fontSize: fontSize ? '9px' : '',
    cursor: 'pointer' as const,
    opacity: 1,
  };

  return (
    <div className={hasClassName || 'dropdown-details-list'} style={{ ...!hasWrapper && { position: 'absolute' } }}>
      {
        newFormatedData?.map((list:any) => (checkmouseEvent
          ? (
            <div
              onMouseLeave={() => handleMouseLeave(list?.title)}
              onMouseEnter={() => handleMouseEnter(list?.title)}
              style={{
                ...rowStyle,
                color: list?.color,
                cursor: list?.disabled ? 'not-allowed' : 'pointer',
                opacity: list?.disabled ? 0.4 : 1,
              }}
              onClick={() => !list?.disabled && handleDropdown(list?.title, details)}
              key={list?.title}
            >
              <span className="dropdown-details-list__icon">{list?.icon}</span>
              <span className="dropdown-details-list__label">{list?.title}</span>
            </div>
          ) : (
            <div
              style={{
                ...rowStyle,
                color: list?.color,
                cursor: list?.disabled ? 'not-allowed' : 'pointer',
                opacity: list?.disabled ? 0.4 : 1,
              }}
              onClick={() => !list?.disabled && handleDropdown(list?.title, details)}
              key={list?.title}
            >
              <span className="dropdown-details-list__icon">{list?.icon}</span>
              <span className="dropdown-details-list__label">{list?.title}</span>
            </div>
          )
        ))
      }

    </div>
  );
};
export default MerchantDropdown;
